import { useEffect, useState } from "react";

import {
  Button,
  Menu,
  MenuItem,
  ThemeProvider,
  createTheme,
} from "@mui/material";
import PopupState, { bindMenu, bindTrigger } from "material-ui-popup-state";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { styled } from "@mui/material/styles";

import i18n from "i18next";
import English from "../../assets/img/countries/english.png";
import Vietnam from "../../assets/img/countries/vietnam.png";
import {
  clearAccessLangCookie,
  getCurrentUrlLang,
  isFunctionalAllowed,
  markExplicitLangNavigation,
  setAccessLangCookie,
} from "../../utils/cookieConsent";

const theme = createTheme({
  palette: {
    button: {
      color: "#3A505F",
    },
  },
});

const StyleButton = styled(Button)(() => ({
  color: "#3A505F",
  fontSize: "14px",
  fontWeight: "400",
  backgroundColor: "transparent",
  textTransform: "capitalize",
  "&:hover": {
    backgroundColor: "transparent",
  },
}));

const MenuStyle = styled(Menu)(() => ({
  "& .MuiList-root": {
    backgroundColor: "#F1F6FA",
    paddingTop: "0",
    color: "#3A505F",
    paddingBottom: "0",
  },
  "& .MuiPaper-root": {
    backgroundColor: "#F1F6FA",
  },
}));

const labelFromCode = (code) => (code === "en" ? "English" : "Vietnamese");

/**
 * Ghi cookie/localStorage chỉ khi đọc lại cookie consent cho thấy functional === true.
 * Luôn đọc live từ document.cookie (hỗ trợ cross-tab).
 */
const persistLanguagePreference = (langCode) => {
  if (!isFunctionalAllowed()) {
    clearAccessLangCookie();
    return false;
  }
  return setAccessLangCookie(langCode);
};

export const LanguageMenu = () => {
  const [language, setLanguage] = useState(() =>
    labelFromCode(getCurrentUrlLang())
  );

  const handleLanguage = (lang, popupState) => {
    popupState?.close();
    setLanguage(lang);

    const newLang = lang === "English" ? "en" : "vi";
    i18n.changeLanguage(newLang);

    // Đánh dấu điều hướng chủ động (cho phép giữ /vi khi functional đang tắt)
    markExplicitLangNavigation(newLang);

    // Re-check consent ngay trước khi ghi — Tab khác có thể đã tắt toggle
    persistLanguagePreference(newLang);

    const currentPath = window.location.pathname;
    const newPath = currentPath.replace(/^\/(en|vi)/, `/${newLang}`);
    // assign để Back/Forward còn trong history (test Back → /vi)
    window.location.assign(newPath);
  };

  useEffect(() => {
    const urlLang = getCurrentUrlLang();
    setLanguage(labelFromCode(urlLang));
    i18n.changeLanguage(urlLang);
    persistLanguagePreference(urlLang);
  }, []);

  useEffect(() => {
    const handleConsentChange = () => {
      if (!isFunctionalAllowed()) {
        clearAccessLangCookie();
        return;
      }
      persistLanguagePreference(getCurrentUrlLang());
    };

    const handleHistory = () => {
      const urlLang = getCurrentUrlLang();
      setLanguage(labelFromCode(urlLang));
      i18n.changeLanguage(urlLang);
      persistLanguagePreference(urlLang);
    };

    window.addEventListener("cookie-consent-changed", handleConsentChange);
    window.addEventListener("popstate", handleHistory);
    window.addEventListener("pageshow", handleHistory);

    return () => {
      window.removeEventListener("cookie-consent-changed", handleConsentChange);
      window.removeEventListener("popstate", handleHistory);
      window.removeEventListener("pageshow", handleHistory);
    };
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <PopupState variant="popover" popupId="language-menu">
        {(popupState) => (
          <>
            <StyleButton {...bindTrigger(popupState)}>
              <img
                src={language === "English" ? English : Vietnam}
                alt=" Language"
                style={{ width: 24, marginRight: 5 }}
              />
              <p>{language === "English" ? "English" : "Tiếng Việt"}</p>
              <KeyboardArrowDownIcon />
            </StyleButton>

            <MenuStyle {...bindMenu(popupState)}>
              <MenuItem onClick={() => handleLanguage("English", popupState)}>
                <img
                  src={English}
                  alt="English"
                  style={{ width: 30, marginRight: 10 }}
                />
                English
              </MenuItem>

              <MenuItem
                onClick={() => handleLanguage("Vietnamese", popupState)}
              >
                <img
                  src={Vietnam}
                  alt="Vietnamese"
                  style={{ width: 30, marginRight: 10 }}
                />
                Tiếng Việt
              </MenuItem>
            </MenuStyle>
          </>
        )}
      </PopupState>
    </ThemeProvider>
  );
};
